(function ($) {
	FWP.hooks.addAction('facetwp/refresh/searchable_checkboxes', function ($this, facet_name) {
		var selected_values = [];
		$this.find('.facetwp-checkbox.checked').each(function () {
			selected_values.push($(this).attr('data-value'));
		});
		FWP.facets[facet_name] = selected_values;
	});

	FWP.hooks.addFilter('facetwp/selections/searchable_checkboxes', function (output, params) {
		var choices = [];
		$.each(params.selected_values, function (val) {
			var $item = params.el.find('.facetwp-checkbox[data-value="' + val + '"]');
			if ($item.len()) {
				var choice = $($item.html());
				choice.find('.facetwp-counter').remove();
				choice.find('.facetwp-expand').remove();
				choices.push({
					value: val,
					label: choice.text(),
				});
			}
		});
		return choices;
	});
})(fUtil);
